<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">设施台账</div>
    </div>
    <div class="modul-content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="设施检测维修台账" name="1"></el-tab-pane>
        <el-tab-pane label="安全管理台账" name="2"></el-tab-pane>
        <el-tab-pane label="应急管理台账" name="3"></el-tab-pane>
        <el-tab-pane label="巡检台账" name="4"></el-tab-pane>
        <el-tab-pane label="监测台账" name="5"></el-tab-pane>
      </el-tabs>
      <!-- 查询 -->
      <div class="query-form">
        <el-form :inline="true" :model="form" ref="form">
          <el-form-item label="台账名称" prop="bridgeName"
            ><el-input
              v-model="form.bridgeName"
              clearable
              placeholder="请输入台账名称"
            ></el-input
          ></el-form-item>
          <el-form-item label="时间">
            <el-date-picker
              v-model="time"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="timeChange"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            ><el-button type="primary" @click="tableReq(1)"
              >查询</el-button
            ></el-form-item
          >
        </el-form>
        <el-form :inline="true">
          <el-form-item
            ><el-button plain @click="onExport"
              >批量导出</el-button
            ></el-form-item
          >
          <el-form-item
            ><el-button plain @click="editRow">新增</el-button></el-form-item
          >
        </el-form>
      </div>
      <el-table
        class="tableStyle"
        v-loading="loading"
        height="calc(100vh - 400px)"
        border
        style="width: 100%"
        :data="tableData"
        :header-cell-style="{
          background: '#FAFAFA',
          color: '#000000',
          'text-align': 'left'
        }"
      >
        <el-table-column
          label="序号"
          align="left"
          type="index"
          width="50px"
        ></el-table-column>
        <el-table-column
          prop="bridgeName"
          label="名称"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="reportName"
          label="上传人"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="reportTime"
          label="上传时间"
          align="left"
        ></el-table-column>
        <el-table-column prop="bridgeName" label="台账" align="left" w>
          <template slot-scope="scope">
            <img
              src="@/assets/image/old/文件夹@2x.png"
              alt=""
              style="width: 20px; height: 20px; margin-right: 5px"
            />
            <a
              href="javascript:void(0);"
              @click="detailsRow(scope.row)"
              style="color: #11528b"
              >{{ scope.row.fileName }}</a
            >
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" align="left">
          <template #default="scope">
            <el-button class="btn" type="text" @click="editRow(scope.row)"
              >编辑</el-button
            >
            <el-button class="btn" type="text" @click="delRow(scope.row)"
              >删除</el-button
            >
            <el-button class="btn" type="text" @click="detailsRow(scope.row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--  -->
      <div style="text-align: center; margin: 20px 0 0">
        <el-pagination
          @size-change="handleSizeChange"
          :hide-on-single-page="!total"
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          :page-sizes="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 点击编辑或新增弹出框 -->
    <div
      class="caozuotianbiao"
      :style="caozuoxy == true ? 'display: none;' : ''"
    >
      <el-form class="caozuotianbiao-from" label-position="left">
        <div class="modul-top">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">设施台账</div>
        </div>
        <div
          style="
            position: absolute;
            top: 15px;
            right: 15px;
            border-radius: 50%;
            overflow: hidden;
            width: 30px;
            height: 30px;
          "
          @click="quxiao"
        >
          <img
            src="../../../assets/image/old/删除@2x.png"
            alt="关闭"
            style="width: 100%; height: 100%"
          />
        </div>
        <el-row>
          <el-col :span="11">
            <el-form-item label="名称" label-width="80px">
              <!-- <el-select v-model="bridgeName" @change="bridgeChange" @clear="getSetUpEarlyWarning()" filterable
								clearable placeholder="请选择">
								<el-option v-for="(item,index) in bridgeData" :key="index" :label="item.bridgeName"
									:value="item.bridgeUuid">
								</el-option>
							</el-select> -->
              <el-input
                type="text"
                v-model="addAndAmendData.bridgeName"
                @change="bridgeChange"
                placeholder="请输入文件名"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="上传人" label-width="80px">
              <!-- <el-input type="text" v-model="addAndAmendData.reportName" :disabled="true" @change="bridgeChange" placeholder="请输入文件名"></el-input> -->
              {{ addAndAmendData.reportName }}
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="上传时间" label-width="80px">
              <!-- <el-input type="text" v-model="addAndAmendData.reportTime" :disabled="true" @change="bridgeChange" placeholder="请输入文件名"></el-input> -->
              {{ addAndAmendData.reportTime }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="上传文件" label-width="80px">
          <el-upload
            class="upload-demo"
            drag
            :action="api + '/file/upload'"
            :limit="1"
            :on-preview="handlePictureCardPreview"
            :on-success="success"
            :file-list="fileList"
            multiple
            accept=".jpg,.png,.docx,.doc,.pdf"
            :before-upload="uploadSheZhi"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>点击上传</em>
            </div>
            <div slot="tip" class="el-upload__tip">
              只能上传.jpg/.png/.docx/.doc/.pdf文件，且不超过100M
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="台账类型:" label-width="80px">
          <el-radio-group v-model="state">
            <el-radio :label="0">设施检测维修台账</el-radio>
            <el-radio :label="1">安全管理台账</el-radio>
            <el-radio :label="2">应急管理台账</el-radio>
            <el-radio :label="3">巡检台账</el-radio>
            <el-radio :label="4">监测台账</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          style="
            text-align: right;
            position: absolute;
            bottom: 10px;
            right: 25px;
          "
        >
          <el-button type="primary" @click="isOK">确定</el-button>
          <el-button @click="quxiao">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {number} from 'echarts'
export default {
  name: 'DeqingBridgeAndTunnelQiaoLiangTaiZhang',
  data() {
    return {
      activeName: '1',
      form: {
        bridgeName: '',
        startTime: '',
        endTime: '',
        state: 0,
        pageNum: 1,
        pageSize: 10
      },
      time: [],
      loading: false,
      tableData: [],
      total: 0,
      caozuoxy: true,
      addAndAmendData: {
        bridgeName: '',
        bridgeUuid: '',
        fileName: '',
        fileUrl: '',
        reportName: '',
        reportTime: '',
        reportUuid: '',
        state: 0
      },
      addAndAmendData: [],
      bridgeName: '',
      fileList: [],
      bridgeData: [],
      userInfo: [],
      state: 0
    }
  },

  mounted() {
    this.tableReq()
    this.getBiBridgeBoPage()
    this.userInfo = JSON.parse(JSON.stringify(this.$store.state.userintfo))
  },
  watch: {
    state(one, two) {
      // console.log(one);
      this.addAndAmendData.state = one
      // console.log(this.addAndAmendData);
    }
  },
  computed: {
    api() {
      return this.$config.host
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab.index, event)
      // this.activeName = tab.index ;
      this.form.state = Number(tab.index)
      this.tableReq()
    },
    //时间选择
    timeChange(e) {
      console.log(e)

      let time = JSON.parse(JSON.stringify(e))
      console.log(time)
      if (time != undefined && time.length > 0) {
        this.form.startTime = time[0]
        this.form.endTime = time[1]
      } else {
        this.form.startTime = ''
        this.form.endTime = ''
      }
    },
    //获取数据
    async tableReq(page) {
      console.log('时间》》', this.time)
      // this.loading = true
      if (page) {
        this.form.pageNum = page
      }
      let data = {
        ...this.form
      }
      // console.log(data);
      const res = await this.$api.sendPost(
        '/bridgeStandingBook/getBridgeStandingBook',
        data
      )
      // this.loading = false
      // console.log('数据列表',res);
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
        }
        console.log('数据列表>>', this.tableData)
      }
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.form.pageSize = val
      this.tableReq(1)
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.form.pageNum = val
      this.tableReq()
    },
    //导出
    async onExport() {
      let data = {
        ...this.form
      }
      const res = await this.$api.sendDownload(
        '/bridgeStandingBook/batchDownload',
        data
      )
      console.log('res', res)
      let reader = new FileReader()
      reader.readAsDataURL(res)
      reader.onload = (e) => {
        let a = document.createElement('a')
        a.download = '设施台账.zip'
        a.href = e.target.result
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
      // let fileName = '设施台账';
      // let blobObject = new Blob([res], {
      // 	// type: 'application/vnd.ms-excel,charset=utf-8'
      // 	type: 'application/zip;charset-UTF-8'
      // }); //如果是字节流
      // //是IE浏览器
      // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      // 	window.navigator.msSaveOrOpenBlob(blobObject, fileName);
      // } else {
      // 	//火狐谷歌都兼容
      // 	//模板中要有一个预定义好的a标签
      // 	var link = document.createElement('a');
      // 	link.href = window.URL.createObjectURL(blobObject); //如果是字节流
      // 	link.target = '_blank';
      // 	link.download = fileName;
      // 	link.click();
      // 	//释放内存
      // 	window.URL.revokeObjectURL(link.href);
      // }
    },
    //编辑和新增
    async editRow(data) {
      this.caozuoxy = false
      if (data.id != undefined) {
        this.bridgeName = data.bridgeName
        // console.log(data);
        if (data.fileUrl != '') {
          this.fileList = [
            {
              name: data.fileName,
              url: data.fileUrl
            }
          ]
        }
        this.addAndAmendData = data
      } else {
        this.fileList = []
        this.bridgeName = ''
        this.addAndAmendData = {
          bridgeName: '',
          bridgeUuid: '',
          fileName: '',
          fileUrl: '',
          reportName: this.userInfo.accountName,
          reportTime: this.$moment().format('YYYY-MM-DD'),
          reportUuid: this.userInfo.accountUuid,
          state: 0
        }
        this.state = 0
        // console.log('请求体',this.addAndAmendData);
      }
    },
    async isOK() {
      console.log(this.addAndAmendData)
      if (
        this.addAndAmendData.fileUrl == '' ||
        this.addAndAmendData.bridgeUuid == ''
      ) {
        alert('您还有内容未添加')
      } else {
        this.caozuoxy = true
        this.loading = true
        // console.log('请求体',this.addAndAmendData);
        const res = await this.$api.sendPost(
          '/bridgeStandingBook/saveOrUpdate',
          this.addAndAmendData
        )
        this.loading = false
        // console.log('请求结果',res);
        this.tableReq()
      }
    },
    quxiao() {
      this.caozuoxy = true
    },
    //删除
    async delRow(data) {
      console.log(data)
      const res = await this.$api.sendGet('/bridgeStandingBook/delete', {
        id: data.id
      })
      if (res.errcode == 0) {
        this.tableReq()
      }
    },
    // 设施名称选择
    async bridgeChange(e) {
      // this.bridgeData.map(item => {
      // 	if (item.bridgeUuid == e) {
      // 		this.addAndAmendData.bridgeName = item.bridgeName
      // 	}
      // 	return
      // })
      console.log(e)
      this.addAndAmendData.bridgeUuid = e
      // console.log('设施信息',this.addAndAmendData);
    },
    // 获取-设施名称列表
    async getBiBridgeBoPage() {
      let data = {
        pageSize: 99999,
        pageNum: 1
      }
      const res = await this.$api.sendPost('/biBridge/getBiBridgeBoPage', data)
      // console.log("设施名称", res);
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          this.bridgeData = res.data.list
        } else {
          this.bridgeData = []
        }
      }
    },
    //上传文件
    success(response, file, fileLis) {
      console.log('上传文件信息', response)
      this.addAndAmendData.fileName = response.data.fileName
      this.addAndAmendData.fileUrl = response.data.urlPath
      // console.log('上传成功',response);
      // console.log('设施信息',this.addAndAmendData);
    },
    uploadSheZhi(file) {
      if (file.size > 100 * 1024 * 1024) {
        alert('上传文件过大')
        return false //必须返回false
      } else {
      }
    },
    //下载
    detailsRow(data) {
      console.log('下载数据', data)
      const a = document.createElement('a')
      a.href = data.fileUrl
      // a.download = '文件名1'; // 下载后文件名
      a.setAttribute('download', data.fileName)
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click() // 点击下载
      document.body.removeChild(a) // 下载完成移除元素
    },
    handlePictureCardPreview(file) {
      console.log(file.response.data.urlPath)
      const a = document.createElement('a')
      a.href = file.response.data.urlPath
      // a.download = '文件名1'; // 下载后文件名
      a.setAttribute('download', file.response.data.fileName)
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click() // 点击下载
      document.body.removeChild(a) // 下载完成移除元素
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__item {
  font-size: 16px;
}

.caozuotianbiao {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.caozuotianbiao-from {
  width: 70%;
  height: 600px;
  background-color: #fff;
  text-align: left;
  padding: 20px;
  position: relative;
  padding-top: 60px;
  padding-left: 120px;

  .modul-top {
    position: absolute;
    left: 15px;
    top: 0;
  }
}
</style>
